import React, { useState, useEffect } from 'react';
//Components
import Loading from '../../../components/Loading/Loading';
import FichaPrefeituraContainer from './components/FichaPrefeituraContainer';
import MainCard from '../../../components/MainCard/MainCard';
import NovaPrefeitura from './NovaPrefeitura';
//Api
import prefeitura_api from '../../../api/prefeitura_api';
export default function FichaPrefeitura({ id, loading, setLoading, btnVoltar, permissao }) {
    //Estado que guarda os dados que vão ser apresentados na tela
    const [prefeitura, setPrefeitura] = useState({});
    //Estado que controla a apresentação da tela de edição
    const [editarPrefeitura, setEditarPrefeitura] = useState(null);
    //Função de clique do botão de editar
    const editar = () => setEditarPrefeitura(id);
    //Carrega os dados da prefeitura na inicialização do componente
    useEffect(() => {
        loadDadosPrefeitura();
    }, []);
    
    //Carrega os dados da prefeitura
    const loadDadosPrefeitura = () => {
        setLoading(true);
        setEditarPrefeitura(null);
        prefeitura_api.GetItem(id).then(response => {
            setPrefeitura(response.data);
            setLoading(false);
        })
    };

    //Controle da apresentação da tela de editar
    if (editarPrefeitura != null) {
        return <NovaPrefeitura id={editarPrefeitura} loading={loading} setLoading={setLoading} btnVoltar={() => {
            setEditarPrefeitura(null);
            btnVoltar();
        }} />
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard btnVoltar={btnVoltar} btnEditar={permissao === "Editar" ? editar : null}>
                <FichaPrefeituraContainer prefeitura={prefeitura} municipios={prefeitura.cidade} usuarioResponsavel={prefeitura.usuarioResponsavel} />
            </MainCard>
        </>
    )
}
